// extracted by mini-css-extract-plugin
module.exports = {"SpinnerSmall":"SpinnerSmall_SpinnerSmall__2fIMT","Image":"SpinnerSmall_Image__2QaV0","load":"SpinnerSmall_load__jACqP"};